// The post-sign-in route table.
export const SIGN_IN_PATH = '/'
// The sign-up form is the landing hero; app-origin CTAs point at it instead of the website's /sign-up hop.
export const SIGN_UP_ANCHOR = 'get-started'
export const SIGN_UP_HREF = `${SIGN_IN_PATH}#${SIGN_UP_ANCHOR}`
export const VERIFY_PHONE_PATH = '/onboarding/verify-phone'
export const DEFAULT_POST_LOGIN_DESTINATION = '/dashboard'
// The get-the-app wall: where the phone step lets out, and nothing else does.
export const POST_REGISTRATION_DESTINATION = '/onboarding/complete-registration'
